import productEnum from './product-enum';

export function handleDefaults(defaultObj, dynamicObj) {
	for (const key in dynamicObj) {
		defaultObj[key] = dynamicObj[key];
	}
	return defaultObj;
}

export function getProductNameById(id) {
	let productName = '';
	if (id) {
		for (const key in productEnum) {
			if (productEnum[key].id === id) {
				productName = productEnum[key].name;
				break;
			}
		}
	}
	return productName;
}

export function log() {}
